import { defineStore } from "pinia";
import { labels, utilities } from "@/constants/Inputs";
import type { DisplayItem } from "@/types/displayItem";

interface InputState {
  selectedLabel: string;
  brief: string;
  selectedUtility: string;
  assets: DisplayItem[];
  selectedAssets: DisplayItem[];
  inputS3Url: string;
  inputCanvasJson: any;
}

export const useInputStore = defineStore("input", {
  state: (): InputState => ({
    selectedLabel: labels.promotional,
    brief: "",
    selectedUtility: utilities.generate,
    assets: [],
    selectedAssets: [],
    inputS3Url: "",
    inputCanvasJson: null,
  }),
  actions: {
    setSelectedLabel(label: string) {
      this.selectedLabel = label;
    },
    setBrief(brief: string) {
      this.brief = brief;
    },
    setSelectedUtility(utility: string) {
      this.selectedUtility = utility;
    },
    setInputS3Url(url: string) {
      this.inputS3Url = url;
    },
    setInputCanvasJson(json: any) {
      this.inputCanvasJson = json;
    },
    resetInput() {
      this.selectedLabel = labels.promotional;
      this.brief = "";
      this.selectedUtility = utilities.generate;
      this.assets = [];
      this.selectedAssets = [];
      this.inputS3Url = "";
      this.inputCanvasJson = null;
    },
    // Manage assets
    setAssets(assets: DisplayItem[]) {
      this.assets = assets;
    },
    setSelectedAssets(assets: DisplayItem[]) {
      this.selectedAssets = assets;
    },
  },
});
